// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"542":"746e9609","973":"553ce45c","984":"553ce45c"}[chunkId] + ".css";
};